<!--官网首页菜单-->
<template>
  <div class="home">
    <div class="header"><!-- :class="current === 2 ? 'bg':''"-->
      <div class="logo">
        <!-- <img src="@/assets/API_logo_super.png" alt=""> -->
        <div class="logo_img">
          <img src="../assets/bigLogo.svg" alt="">
        </div>
        <span class="logo_text">数聚变</span>
        <div class="logo_img_1">
          <img src="@/assets/API_logo.png" alt="">
        </div>
      </div>
      <div class="menu">
        <ul>
          <li class="liMenu" v-for="item in liList" :key="item.name" @click="anchorHandle(item.id)">
            <span :class="current === item.id ? 'active':''">
              {{item.name}}
            </span>
            <div class="itemMenu" v-if='item.name == "解决方案"'>
              <p @click.stop='$router.push("EnterpriseSolution")' :style="{color:activeStep == 0 ? '#1890ff':''}">企业数据管理解决方案</p>
              <p @click.stop='$router.push("ApiSolution")' :style="{color:activeStep == 1 ? '#1890ff':''}">数据API解决方案</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="btns">
        <el-button size='medium' class="btn1" @click='link(0)'>立即注册</el-button>
        <el-button size='medium' class="btn" @click='link(1)'>登录</el-button>
      </div>
    </div>
    <div>
      <transition mode="out-in" name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      activeStep: null,
      liList: [
        {
          id: 0,
          name: '首页'
        },
        {
          id: 1,
          name: '解决方案'
        },
        {
          id: 4,
          name: 'API市场'
        },
        {
          id: 2,
          name: '合作伙伴'
        },
        {
          id: 3,
          name: '使命愿景'
        },
        {
          id: 5,
          name: '商务合作'
        }
      ]
    }
  },
  watch: {
    immediate:true,
    $route() {
      if(this.$route.name == 'ApiSolution' || this.$route.name == 'EnterpriseSolution') {
        this.$store.commit('CHANGE_CURRENT',1)
        this.activeStep = this.$route.name == 'ApiSolution' ? 1 : 0;
      } else {
        this.activeStep = null
      }
    }
  },
  created() {},
  mounted () {},
  computed: {
    ...mapState(["current"]),
  },
  methods: {
    anchorHandle(val) {
      this.$store.commit('CHANGE_CURRENT',val)
      if(this.$route.name !== 'Index') {
        this.$router.push('Index')
        this.activeStep = null
      }
      if(val === 4) {
        console.log('link to apimarket')
        window.open(`${process.env.VUE_APP_APIMARKETURL}/sjb/APIStore/all`,"_blank")
        // window.open(`http://localhost:8089/sjb/APIStore/all`,"_blank")
      }
    },
    link(val) {
      if(val) {
        console.log('link to login')
        // window.location.href = "http://localhost:8089/sjb/login"
        window.open(`${process.env.VUE_APP_APIMARKETURL}/sjb/login`,"_blank")
        //  window.open(`http://localhost:8089/sjb/login`,"_blank")
      } else {
        console.log('link to register')
        window.open(`${process.env.VUE_APP_APIMARKETURL}/sjb/register`,"_blank")
        // window.open(`http://localhost:8089/sjb/register`,"_blank")
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.active {
  color: #1890ff;
}
.bg {
  background: rgba(0,0,0,.7) //#383939;
}
.home {
  width: 100%;
  .header {
    backdrop-filter: blur(20px);
    // box-shadow: 0 0 30px 10px rgba(0, 0, 0, .3);
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 80px;
    .logo {
      width: 26%;
      display: flex;
      .logo_img {
        width: 150px;
        img {
          width: 100%;
          margin-top: -30px;
        }
      }
      .logo_img_1 {
        width: 200px;
        img {
          width: 100%;
          margin: 3px 0 0 -28px;
        }
      }
      .logo_text {
        width: 80px;
        display: inline-block;
        color: #fff;
        font-size: 22px;
        line-height: 90px;
        position: relative;
        margin-left: 20px;
      }
      .logo_text::before {
          content: '';
          display: inline-block;
          width: 2px;
          height: 40px;
          background: #fff;
          position: absolute;
          top: 25px;
          left: -20px;
        }
    }
    .menu {
      width: 100%;
      ul {
        float: right;
        display: flex;
        li {
          list-style: none;
          width: 130px;
          height: 80px;
          line-height: 80px;
          color: #fff;
          padding: 0 10px;
          text-align: center;
          font-size: 18px;
        }
        li:nth-of-type(1) {
          width: 90px;
        }
        li:nth-of-type(2) {
          position: relative;
          .itemMenu {
            display: none;
            background: rgba(0,0,0,.3);
            width: 195px;
            text-align: left;
            position: absolute;
            top: 80px;
            left: -25px;
            padding: 5px 5px 5px 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,.15);
            p {
              padding: 0;
              margin: 0;
              color: #fff;
              font-size: 16px;
              height: 48px;
              line-height: 48px;
            }
            p:hover {
              color: #1890ff;
            }
          }
        }
        li:hover {
          color: #1890ff;
          cursor: pointer;
        }
        li:nth-of-type(2):hover .itemMenu{
          display: block;
        }
      }
    }
    .btns {
      visibility: hidden;
      padding-right: 2%;
      // width: 20%;
      line-height: 70px;
      text-align: right;
      .btn1 {
        background: #1890ff;
        border: none;
        /deep/span {
          color: #fff;
        }
      }
      .btn {
        margin-left: 20px;
        background: transparent;
        /deep/span {
          color: #fff;
        }
      }
    }
  }
}
</style>
